/*
 *   File : add-goal.jsx
 *   Author : https://evoqins.com
 *   Description : Add Goal form with validation
 *   Version : 1.0.2
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CustomFileUpload,
  Input,
  ToggleInput,
} from "../../Components/FormElements";
import { PrimaryButton } from "../../Components/Cta";
import { APIService } from "../../Service";
import { toast } from "react-toastify";

export default function AddGoal() {
  const navigate = useNavigate();

  // --- form states ---
  const [goalName, setGoalName] = useState("");
  const [goalNameError, setGoalNameError] = useState(false);

  const [tag, setTag] = useState("");
  const [tagError, setTagError] = useState(false);

  const [file, setFile] = useState(null);
  const [imageLink, setImageLink] = useState("");
  const [fileError, setFileError] = useState(false);

  const [recommended, setRecommended] = useState(false);

  const [minSip, setMinSip] = useState("");
  const [minSipError, setMinSipError] = useState(false);

  const [lumpsum, setLumpsum] = useState("");
  const [lumpsumError, setLumpsumError] = useState(false);

  // --- validation and submit ---
  const handleSave = () => {
    let hasError = false;

    // Reset all errors to false
    setGoalNameError(false);
    setTagError(false);
    setFileError(false);
    setMinSipError(false);
    setLumpsumError(false);

    if (!goalName.trim()) {
      setGoalNameError("Please enter a goal name.");
      hasError = true;
    }

    if (!tag.trim()) {
      setTagError("Please select a tag for this goal.");
      hasError = true;
    }

    if (!imageLink.trim()) {
      setFileError("Please provide an image URL for this goal.");
      hasError = true;
    }

    if (!minSip || Number(minSip) <= 0) {
      setMinSipError("Please enter a valid minimum SIP amount greater than 0.");
      hasError = true;
    }

    if (!lumpsum || Number(lumpsum) <= 0) {
      setLumpsumError("Please enter a valid lumpsum amount greater than 0.");
      hasError = true;
    }

    if (hasError) return;

    _addGoal();
  };

  const _addGoal = () => {
    const is_post = true;
    const payload = [
      {
        goal_style_id: null,
        name: goalName,
        image: imageLink,
        min_sip: minSip,
        min_lumpsum: lumpsum,
        tag,
        recommended,
      },
    ];
    APIService(is_post, "goal/upsert", payload)
      .then((response) => {
        if (response.status_code === 200) {
          // console.log(response.data);
          toast.success(response.message);
          navigate("/manage-goal");
        } else {
          // setEmptyScreen(true);
          console.error(response);
        }
        // setLoader(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoader(false);
      });
  };

  function _handleAuthorImageUpload(selectedFile) {
    setFileError(false);
    setFile(selectedFile);
  }

 

  return (
    <div className="row px-3 pt-3">
      <div className="col-lg-8">
        <div className="e-border-1px-pale-lavender e-border-radius-16 p-3 e-bg-ghost-white-dark">
          <h5 className="e-font-16 e-font-weight-600 e-text-eerie-black">
            Update details
          </h5>

          {/* Goal Name */}
          <div className="row pt-3">
            <Input
              id="goal-name"
              type="text"
              label="Goal Name"
              placeholder="Enter Goal name"
              onKeyPress={handleSave}
              require
              value={goalName}
              autoFocus
              error={goalNameError}
              labelStyle="e-text-black e-font-weight-400 e-primary-font-poppins e-font-14 pb-2"
              className="w-100  text-capitalize"
              handleChange={(val) => {
                setGoalName(val);
                setGoalNameError(false);
              }}
            />
          </div>

          {/* Tag */}
          <div className="row pt-3 align-items-center">
            <div className="d-flex justify-content-between">
              <h5 className="e-font-14 e-font-weight-400 e-primary-font-poppins e-text-black">
                Tag <span className="text-danger">*</span>
              </h5>
              <div className="d-flex align-items-center mb-2">
                <img
                  src={
                    require("../../Assets/Image/ManageBasket/info.svg").default
                  }
                  alt="info"
                />
                <p className="ps-2 e-font-12 m-0 e-font-weight-500 e-primary-font-poppins">
                  You can only add a tag
                </p>
              </div>
            </div>
            <div className="col-7">
              <Input
                require
                className="w-100"
                value={tag}
                type="text"
                error={tagError}
                onKeyPress={handleSave}
                handleChange={(val) => {
                  setTag(val);
                  setTagError(false);
                }}
              />
            </div>
          </div>

          {/* Show tag toggle */}
          <div className="row py-2">
            <div className="col">
              <ToggleInput
                label={" Show recommend tag in card"}
                checked={recommended}
                onChange={setRecommended}
                labelStyle={
                  " e-primary-font-poppins e-font-14 e-font-weight-400 e-text-eerie-black"
                }
              />
            </div>
          </div>

          {/* Upload Image */}
          <div className="pt-3">
            <h5 className="e-font-14 e-font-weight-400 text-capitalize e-primary-font-poppins pb-2">
              Upload goal image<span className="text-danger">*</span>
            </h5>
            <CustomFileUpload
              file={file || imageLink}
              type={1}
              onKeyPress={handleSave}
              fileSize={10}
              handleClear={() => {
                setFile(null);
                setFileError(false);
                setImageLink("");
              }}
              error={fileError}
              handleChange={_handleAuthorImageUpload}
              onUploadComplete={(url) => setImageLink(url)}
            />
            {fileError && (
              <p className="text-danger e-font-12 pt-1">
                Please upload a goal image.
              </p>
            )}
          </div>
        </div>

        {/* Min SIP & Lumpsum */}
        <div className="row pt-3">
          <div className="col">
            <div className="e-border-1px-pale-lavender e-border-radius-16 p-3 e-bg-ghost-white-dark">
              <h5 className="e-font-16 p-0 m-0 e-font-weight-600 e-text-eerie-black e-primary-font-poppins">
                Min SIP & Lumpsum
              </h5>
              <div className="row row-cols-2">
                <div className="col-12">
                  <div className="d-flex align-items-center py-3">
                    <img
                      src={
                        require("../../Assets/Image/ManageBasket/info.svg")
                          .default
                      }
                      alt="info"
                    />
                    <p className="ps-2 e-font-12 m-0 e-font-weight-500 line-height-24 e-primary-font-poppins">
                      By default we calculate min amount based on selected
                      basket. In case you want a min amount for basket, setup
                      this.
                    </p>
                  </div>
                </div>

                <div className="col position-relative">
                  <Input
                    label="Min SIP"
                    require
                    labelStyle={
                      "e-primary-font-poppins e-font-14 e-font-weight-400 e-text-eerie-black"
                    }
                    type="number"
                    className="w-100 ps-4"
                    value={minSip}
                    error={minSipError}
                    onKeyPress={handleSave}
                    handleChange={(val) => {
                      setMinSip(val);
                      setMinSipError(false);
                    }}
                  />
                  <span className="e-money-marker e-primary-font-poppins">
                    ₹
                  </span>
                </div>

                <div className="col position-relative">
                  <Input
                    label="Min Lumpsum"
                    require
                    labelStyle={
                      "e-primary-font-poppins e-font-14 e-font-weight-400 e-text-eerie-black"
                    }
                    type="number"
                    className="w-100 ps-4"
                    value={lumpsum}
                    error={lumpsumError}
                    onKeyPress={handleSave}
                    handleChange={(val) => {
                      setLumpsum(val);
                      setLumpsumError(false);
                    }}
                  />
                  <span className="e-money-marker e-primary-font-poppins">
                    ₹
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row e-pt-36px pb-3">
          <div className="offset-lg-4 col-lg-4 col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-border-1px-blue py-3 e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
              name="Cancel"
              onPress={() => navigate("/manage-goal")}
            />
          </div>
          <div className="col-lg-4 col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-font-weight-500 py-3 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
              name="Create"
              onPress={handleSave}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
